<template>
    <div>
        <div class="text-h6 font-weight-bold text-darkblue mb-4">Vous souhaitez:</div>
        <v-tabs bg-color="darkblue" fixed-tabs v-model="tabModel">
            <v-tab value="verify">Vérifier votre position</v-tab>
            <v-tab value="register">Vous inscrire en liste d'attente</v-tab>
        </v-tabs>
        <v-form ref="form" @submit.prevent>
            <div class="field_label mt-2">Votre email</div>
            <v-text-field v-model="mailFieldModel" :readonly="isRegisterMailLocked"
                :rules="[$formRules.required, $formRules.email]"></v-text-field>
            <div class="field_label mt-2">Parcours souhaité</div>
            <v-select :items="courseItems" item-title="title" item-value="value" :model-value="selectedCourse"
                @update:model-value="$emit('update:selectedCourse', $event)" :rules="[$formRules.required]"></v-select>
        </v-form>
        <v-tabs-window v-model="tabModel">
            <v-tabs-window-item value="verify">
                <div class="d-flex justify-center">
                    <SportipsButton icon="mdi-check" actionButton @onClick="submitVerify">
                        Vérifier votre position
                    </SportipsButton>
                </div>
            </v-tabs-window-item>
            <v-tabs-window-item value="register">
                <div class="d-flex justify-center">
                    <SportipsButton icon="mdi-account-clock-outline" action-button @onClick="submitRegister">
                        S'inscrire en liste d'attente
                    </SportipsButton>
                </div>
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script>
export default {
    name: 'ListeAttenteForm',
    props: {
        mail: {
            type: String,
            default: '',
        },
        selectedCourse: {
            default: null,
        },
        courseItems: {
            type: Array,
            default: () => [],
        },
        /** Email issu du latoken : forcé en lecture seule sur l'onglet inscription */
        registerMail: {
            type: String,
            default: null,
        },
        tab: {
            type: String,
            default: 'verify',
        },
    },
    emits: ['update:mail', 'update:selectedCourse', 'update:tab', 'verify', 'register'],
    computed: {
        tabModel: {
            get() {
                return this.tab;
            },
            set(value) {
                this.$emit('update:tab', value);
            },
        },
        isRegisterMailLocked() {
            return this.tabModel === 'register' && !!this.registerMail;
        },
        mailFieldModel: {
            get() {
                if (this.isRegisterMailLocked) {
                    return this.registerMail;
                }
                return this.mail;
            },
            set(value) {
                if (this.isRegisterMailLocked) {
                    return;
                }
                this.$emit('update:mail', value);
            },
        },
    },
    methods: {
        async validate() {
            const form = this.$refs.form;
            if (!form) {
                return false;
            }
            const validationResult = await form.validate();
            return validationResult && validationResult.valid !== false;
        },
        async submitVerify() {
            if (!await this.validate()) {
                return;
            }
            this.$emit('verify');
        },
        async submitRegister() {
            if (!await this.validate()) {
                return;
            }
            this.$emit('register');
        },
    },
}
</script>
